import { BrowserOptions } from '@sentry/react'
import * as Sentry from '@sentry/react'
import config from 'shared/config'

export const captureErrorMessage = (message: string, e: any, errorInfo?: any) => {
  Sentry.captureMessage(message, {
    level: 'error',
    contexts: {
      error: e,
      errorInfo: errorInfo ?? {},
    },
  })
}

export const captureMessage = Sentry.captureMessage

export const sentryConfig: BrowserOptions = {
  sampleRate: 0.05,
  dsn: config.SENTRY_DSN,
  release: '4f470635620c6a3d0e311eaf7dbd69cdce0f9886',
  tracesSampleRate: 0.05,
  integrations(integrations) {
    return integrations.filter((i) => i.name !== 'TryCatch')
  },
}
